import { CompactUser } from "../../../../core/CompactModels"

/**
 * One attempt to move money through the card gateway, approved or not.
 *
 * Everything about the job, the invoice and the customer is a copy taken at the moment the card
 * was presented, not a link — a transaction from March still reads correctly after the job has
 * been closed, re-priced or archived.
 */
export default interface PaymentTransaction {
    id?: string

    method?: PaymentTransactionMethods
    kind?: PaymentTransactionKinds
    result?: PaymentTransactionResults
    origin?: PaymentTransactionOrigins

    amount?: number
    tip?: number
    workAmount?: number
    currency?: string

    transactionId?: string
    authCode?: string
    responseCode?: string
    responseText?: string
    avsResponse?: string
    cvvResponse?: string
    cardDetails?: string
    cardType?: string
    gatewayResponse?: string

    jobId?: string
    jobNumber?: string
    jobType?: string
    jobSource?: string
    metroName?: string

    invoiceId?: string
    invoiceNumber?: number

    customerName?: string
    customerPhone?: string
    customerAddress?: string

    techId?: string
    tech?: CompactUser

    creatorUserId?: string
    creatorUser?: CompactUser

    createdAt?: Date
}

export enum PaymentTransactionMethods {
    Card = 1,
    TapToPay = 2
}

export enum PaymentTransactionKinds {
    Sale = 1,
    Refund = 2
}

export enum PaymentTransactionResults {
    Approved = 1,
    Declined = 2,
    Error = 3
}

export enum PaymentTransactionOrigins {
    CustomerWeb = 1,
    TechnicianDevice = 2,
    Console = 3
}

export interface PaymentTransactionsSummary {
    approvedCount?: number
    approvedAmount?: number
    tipAmount?: number
    refundedCount?: number
    refundedAmount?: number
    tapToPayCount?: number
    tapToPayAmount?: number
    webCardCount?: number
    webCardAmount?: number
}
